export enum EAppQueryKey {
  APP_CONFIG = 'app-config'
}
